// DeepAR Loader with CORS workaround
import { loadMockDeepAR } from './mockDeepAR';

// Flag to force mock usage (useful for development)
const FORCE_MOCK = false; // Set to true to force mock usage

export const loadDeepARWithCORSWorkaround = () => {
  return new Promise((resolve, reject) => {
    if (FORCE_MOCK) {
      console.log('🎭 Using Mock DeepAR (forced for development)');
      return loadMockDeepAR().then(resolve).catch(reject);
    }

    // Check if DeepAR is already loaded
    if (window.deepar) {
      resolve(window.deepar);
      return;
    }

    // Try loading DeepAR with CORS workaround
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/deepar@5.6.20/js/deepar.js';
    script.crossOrigin = 'anonymous';
    script.async = true;
    
    // Remove any default headers that might cause CORS issues
    script.onload = () => {
      if (window.deepar) {
        // Override fetch to remove problematic headers for WASM loading
        const originalFetch = window.fetch;
        window.fetch = function(url, options = {}) {
          // If this is a DeepAR WASM request, clean the headers
          if (url.includes('deepar') && url.includes('.wasm')) {
            const cleanOptions = { ...options };
            if (cleanOptions.headers) {
              const cleanHeaders = { ...cleanOptions.headers };
              // Remove problematic headers
              delete cleanHeaders['request-id'];
              delete cleanHeaders['x-request-id'];
              delete cleanHeaders['correlation-id'];
              cleanOptions.headers = cleanHeaders;
            }
            return originalFetch.call(this, url, cleanOptions);
          }
          return originalFetch.call(this, url, options);
        };
        
        resolve(window.deepar);
      } else {
        console.warn('DeepAR script loaded but library not available');
        fallbackToMock();
      }
    };
    
    script.onerror = (error) => {
      console.error('❌ Failed to load DeepAR script:', error);
      fallbackToMock();
    };
    
    const fallbackToMock = () => {
      loadMockDeepAR()
        .then(mockDeepAR => {
          resolve(mockDeepAR);
        })
        .catch(mockError => {
          console.error('❌ Failed to load Mock DeepAR:', mockError);
          reject(new Error('Failed to load DeepAR from all sources: ' + mockError.message));
        });
    };
    
    // Add script to document
    document.head.appendChild(script);
  });
};

// Alternative method using dynamic import with error handling
export const loadDeepARDynamic = async () => {
  if (FORCE_MOCK) {
    console.log('🎭 Using Mock DeepAR (forced for development)');
    return loadMockDeepAR();
  }

  try {
    const deepar = await import('deepar');
    return deepar;
  } catch (error) {
    console.warn('❌ Dynamic import failed:', error);
    return loadMockDeepAR();
  }
};